// MB-I18N-2A — admin EN (extrait de LanguageContext, valeurs inchangées).
export default {
  "os.admin.nav.group.communication": "Communication",
  "os.admin.nav.news": "News",
  "os.admin.nav.group.purchasing": "Purchasing",
  "os.admin.nav.supplier_invoices": "Supplier invoices",
  "os.admin.supinv.title": "Supplier invoices",
  "os.admin.supinv.subtitle": "Electronic invoices received for your shop.",
  "os.admin.supinv.refresh": "Refresh",
  "os.admin.supinv.search_placeholder": "Supplier or number…",
  "os.admin.supinv.filter_all": "All",
  "os.admin.supinv.filter_to_process": "To process",
  "os.admin.supinv.filter_accepted": "Accepted",
  "os.admin.supinv.filter_refused": "Refused",
  "os.admin.supinv.filter_error": "In error",
  "os.admin.supinv.filter_paid": "Paid",
  "os.admin.supinv.filter_unpaid": "Unpaid",
  "os.admin.supinv.col_number": "Number",
  "os.admin.supinv.col_issue": "Issue",
  "os.admin.supinv.col_due": "Due",
  "os.admin.supinv.type_invoice": "Invoice",
  "os.admin.supinv.type_credit": "Credit note",
  "os.admin.supinv.linked": "Supplier linked",
  "os.admin.supinv.unlinked": "Not linked",
  "os.admin.supinv.unknown_supplier": "Unknown supplier",
  "os.admin.supinv.tech_received": "Received",
  "os.admin.supinv.tech_validated": "Validated",
  "os.admin.supinv.tech_waiting_document": "Awaiting document",
  "os.admin.supinv.tech_error": "Error",
  "os.admin.supinv.tech_quarantined": "Quarantine",
  "os.admin.supinv.life_available": "Available",
  "os.admin.supinv.life_accepted": "Accepted",
  "os.admin.supinv.life_refused": "Refused",
  "os.admin.supinv.life_disputed": "Disputed",
  "os.admin.supinv.life_archived": "Archived",
  "os.admin.supinv.pay_unpaid": "Unpaid",
  "os.admin.supinv.pay_paid": "Paid",
  "os.admin.supinv.alert_quarantine": "Quarantine",
  "os.admin.supinv.alert_error": "Technical error",
  "os.admin.supinv.alert_invalid": "Invalid document",
  "os.admin.supinv.view_detail": "View detail",
  "os.admin.supinv.detail_soon": "The detail page is coming soon.",
  "os.admin.supinv.empty_title": "No supplier invoice received yet.",
  "os.admin.supinv.empty_desc": "Electronic invoices received via your future Approved Platform will appear here.",
  "os.admin.supinv.no_results": "No results.",
  "os.admin.supinv.error_title": "Unable to load invoices.",
  "os.admin.supinv.error_desc": "Please try again.",
  "os.admin.supinv.detail_back": "Back to list",
  "os.admin.supinv.detail_ttc": "Total incl. VAT",
  "os.admin.supinv.detail_delivery": "Delivery",
  "os.admin.supinv.detail_currency": "Currency",
  "os.admin.supinv.detail_ht": "Net (excl. VAT)",
  "os.admin.supinv.detail_tva": "VAT",
  "os.admin.supinv.detail_statuses": "Statuses",
  "os.admin.supinv.detail_alerts": "Alerts",
  "os.admin.supinv.detail_alert_misaddressed": "Invoice possibly misaddressed",
  "os.admin.supinv.detail_supplier_identity": "Supplier identity",
  "os.admin.supinv.detail_legal_name": "Legal name",
  "os.admin.supinv.detail_vat": "VAT number",
  "os.admin.supinv.detail_country": "Country",
  "os.admin.supinv.detail_buyer": "Buyer",
  "os.admin.supinv.detail_establishment": "Establishment",
  "os.admin.supinv.detail_lines": "Lines",
  "os.admin.supinv.detail_no_lines": "No lines available.",
  "os.admin.supinv.detail_col_desc": "Description",
  "os.admin.supinv.detail_col_qty": "Qty",
  "os.admin.supinv.detail_col_pu": "Unit price",
  "os.admin.supinv.detail_col_vat": "VAT",
  "os.admin.supinv.detail_col_ht": "Net",
  "os.admin.supinv.detail_col_ttc": "Total incl. VAT",
  "os.admin.supinv.detail_vat_breakdown": "VAT breakdown",
  "os.admin.supinv.detail_no_vat": "No VAT breakdown available.",
  "os.admin.supinv.detail_documents": "Documents",
  "os.admin.supinv.detail_doc_pdf": "PDF document",
  "os.admin.supinv.detail_doc_structured": "Structured document",
  "os.admin.supinv.detail_doc_payload": "Original payload",
  "os.admin.supinv.detail_doc_available": "Available",
  "os.admin.supinv.detail_doc_unavailable": "Unavailable",
  "os.admin.supinv.detail_timeline": "Timeline",
  "os.admin.supinv.detail_no_events": "No events.",
  "os.admin.supinv.detail_loading": "Loading…",
  "os.admin.supinv.detail_evt_attached": "Supplier linked",
  "os.admin.supinv.detail_evt_reattached": "Supplier changed",
  "os.admin.news.title": "News",
  "os.admin.news.subtitle_before": "Communicate with the customers of ",
  "os.admin.news.add_btn": "New post",
  "os.admin.news.no_shop": "Select a shop to manage its news.",
  "os.admin.news.empty_title": "No news published yet.",
  "os.admin.news.empty_desc": "Announce your new items, promotions and events directly to your customers.",
  "os.admin.news.empty_cta": "Create a post",
  "os.admin.news.toast_load_error": "Unable to load news",
  "os.admin.news.toast_created": "Post created",
  "os.admin.news.toast_updated": "Post updated",
  "os.admin.news.toast_archived": "Post archived",
  "os.admin.news.toast_save_error": "Save failed",
  "os.admin.news.toast_archive_error": "Archive failed",
  "os.admin.news.toast_title_required": "Title is required",
  "os.admin.news.toast_dates_invalid": "End date must be after start date",
  "os.admin.news.dialog_new_title": "New post",
  "os.admin.news.dialog_edit_title": "Edit post",
  "os.admin.news.field_title": "Title",
  "os.admin.news.field_title_ph": "e.g. New Pistachio Latte",
  "os.admin.news.field_description": "Description",
  "os.admin.news.field_description_ph": "Describe your post…",
  "os.admin.news.field_category": "Category",
  "os.admin.news.field_start": "Start date",
  "os.admin.news.field_end": "End date",
  "os.admin.news.field_end_hint": "Leave empty for a post with no expiry",
  "os.admin.news.field_status": "Status",
  "os.admin.news.status_draft": "Draft",
  "os.admin.news.status_published": "Published",
  "os.admin.news.archive_title": "Archive",
  "os.admin.news.period_range": "From {start} to {end}",
  "os.admin.news.period_from": "From {start}",
  "os.admin.news.state_draft": "Draft",
  "os.admin.news.state_scheduled": "Scheduled",
  "os.admin.news.state_published": "Published",
  "os.admin.news.state_expired": "Expired",
  "os.admin.news.cat_information": "Information",
  "os.admin.news.cat_promotion": "Promotion",
  "os.admin.news.cat_nouveau_produit": "New product",
  "os.admin.news.cat_fidelite": "Loyalty",
  "os.admin.news.cat_horaires": "Opening hours",
  "os.admin.news.cat_evenement": "Event",
  "os.admin.news.cat_recette": "Recipe",
  "os.admin.news.ai_open_btn": "Generate with AI",
  "os.admin.news.ai_keywords_label": "Instructions or keywords",
  "os.admin.news.ai_keywords_ph": "E.g.: Sunday brunch, €19 set menu, reservation recommended",
  "os.admin.news.ai_tone_label": "Tone",
  "os.admin.news.ai_language_label": "Language",
  "os.admin.news.ai_length_label": "Length",
  "os.admin.news.ai_language_fr": "French",
  "os.admin.news.ai_language_en": "English",
  "os.admin.news.ai_tone_professionnel": "Professional",
  "os.admin.news.ai_tone_chaleureux": "Warm",
  "os.admin.news.ai_tone_dynamique": "Dynamic",
  "os.admin.news.ai_tone_premium": "Premium",
  "os.admin.news.ai_tone_convivial": "Friendly",
  "os.admin.news.ai_length_court": "Short",
  "os.admin.news.ai_length_moyen": "Medium",
  "os.admin.news.ai_length_long": "Long",
  "os.admin.news.ai_generating": "Generating…",
  "os.admin.news.ai_generate_btn": "Generate text",
  "os.admin.news.ai_quota_other": "{count} generations left today",
  "os.admin.news.ai_quota_one": "1 generation left today",
  "os.admin.news.ai_quota_zero": "No generations left today",
  "os.admin.news.ai_toast_quota_exceeded": "Quota reached",
  "os.admin.news.ai_toast_forbidden": "AI generation is reserved for owners and managers",
  "os.admin.news.ai_toast_generic_error": "Generation error",
  "os.admin.news.ai_toast_keywords_required": "Instructions or keywords are required",
  "os.admin.news.image_label": "Image (optional)",
  "os.admin.news.image_add": "Add",
  "os.admin.news.image_replace": "Replace",
  "os.admin.news.image_hint": "JPG, PNG or WebP · 5 MB max · cropped to square",
  "os.admin.common.save": "Save",
  "os.admin.common.cancel": "Cancel",
  "os.admin.common.edit": "Edit",
  "os.admin.common.delete": "Delete",
  "os.admin.common.retry": "Retry",
  "os.admin.common.loading": "Loading…",
  "os.admin.common.empty": "No items",
  "os.admin.common.search": "Search",
  "os.admin.common.filter": "Filter",
  "os.admin.common.close": "Close",
  "os.admin.common.confirm": "Confirm",
  "os.admin.status.pending": "Pending",
  "os.admin.status.preparing": "Preparing",
  "os.admin.status.ready": "Ready",
  "os.admin.status.completed": "Completed",
  "os.admin.status.cancelled": "Cancelled",
  "os.admin.toasts.error": "Something went wrong",
  "os.admin.toasts.success": "Operation successful",
  "os.admin.toasts.update_error": "Update failed",
  "os.admin.orders.filter_active": "Active",
  "os.admin.orders.filter_pending": "Pending",
  "os.admin.orders.filter_preparing": "Preparing",
  "os.admin.orders.filter_ready": "Ready",
  "os.admin.orders.filter_completed": "Completed",
  "os.admin.orders.empty": "No orders",
  "os.admin.orders.pay_wallet": "Wallet",
  "os.admin.orders.pay_cash": "Cash",
  "os.admin.orders.more_items": "+{count} more items",
  "os.admin.orders.total_ht": "Subtotal (excl. VAT)",
  "os.admin.orders.vat": "VAT ({rate}%)",
  "os.admin.orders.total_ttc": "Total (incl. VAT)",
  "os.admin.orders.total": "Total",
  "os.admin.orders.prep_time": "Time: {min} min",
  "os.admin.orders.mark_ready": "Mark ready",
  "os.admin.orders.complete": "Complete",
  "os.admin.orders.toast_updated": "Order updated: {status}",
  "os.admin.products.subtab_products": "Products",
  "os.admin.products.subtab_recipes": "Recipes",
  "os.admin.products.search_placeholder": "Search a product...",
  "os.admin.products.category_placeholder": "Category",
  "os.admin.products.all_categories": "All categories",
  "os.admin.products.library_catalog": "SUPERKAWA Catalog",
  "os.admin.products.new": "New",
  "os.admin.products.saving_prices": "Saving…",
  "os.admin.products.save_prices": "Save prices ({count})",
  "os.admin.products.recommended_count": "{count} / 70 recommended products",
  "os.admin.products.concise_hint": " · a concise menu sells better",
  "os.admin.products.col_product": "Product",
  "os.admin.products.col_category": "Category",
  "os.admin.products.col_price": "Price",
  "os.admin.products.col_status": "Status",
  "os.admin.products.col_actions": "Actions",
  "os.admin.products.reorder_start": "Reorder Workspace",
  "os.admin.products.reorder_done": "Done",
  "os.admin.products.reorder_hint": "Use the ↑ / ↓ arrows to order your products within each category. The POS reflects this order immediately.",
  "os.admin.products.reorder_error": "Reorder failed. Please try again.",
  "os.admin.products.move_up": "Move up",
  "os.admin.products.move_down": "Move down",
  "os.admin.products.priority_add": "Mark as Priority",
  "os.admin.products.priority_remove": "Remove from Priority",
  "os.admin.products.priority_on": "Added to Priority",
  "os.admin.products.priority_off": "Removed from Priority",
  "os.admin.products.priority_error": "Update failed. Please try again.",
  "os.admin.products.status_draft": "Draft",
  "os.admin.products.status_active": "Active",
  "os.admin.products.status_inactive": "Inactive",
  "os.admin.products.empty": "No products found",
  "os.admin.products.dialog_edit_title": "Edit product",
  "os.admin.products.dialog_new_title": "New product",
  "os.admin.products.field_name": "Name",
  "os.admin.products.field_description": "Description",
  "os.admin.products.field_category": "Category",
  "os.admin.products.field_price_s": "Price — Size S ({currency})",
  "os.admin.products.field_price_l": "Price — Size L (optional) ({currency})",
  "os.admin.products.price_l_hint": "Leave empty to disable size L",
  "os.admin.products.field_tax_category": "Tax category (VAT)",
  "os.admin.products.tax_category_hint": "France only — determines the applied VAT rate (leave \"Not set\" for default behaviour).",
  "os.admin.products.tax_cat_none": "Not set",
  "os.admin.products.tax_cat_food": "Food",
  "os.admin.products.tax_cat_soft_drink": "Soft drink",
  "os.admin.products.tax_cat_grocery": "Grocery",
  "os.admin.products.tax_cat_alcohol": "Alcohol",
  "os.admin.products.field_available": "Available for sale",
  "os.admin.products.placeholder_name": "E.g. Hazelnut Latte",
  "os.admin.products.placeholder_description": "Short description...",
  "os.admin.products.create": "Create",
  "os.admin.products.confirm_disable": "Disable this product?",
  "os.admin.products.toast_name_price_required": "Name and price required",
  "os.admin.products.toast_no_shop": "No store selected — cannot create the product",
  "os.admin.products.toast_updated": "Product updated",
  "os.admin.products.toast_created": "Product created",
  "os.admin.products.toast_create_error": "Creation failed",
  "os.admin.products.toast_disabled": "Product disabled",
  "os.admin.products.toast_delete_error": "Deletion failed",
  "os.admin.products.toast_prices_updated": "{count} prices updated",
  "os.admin.products.toast_prices_error": "Error saving prices",
  "os.admin.products.image_label": "Product photo",
  "os.admin.products.image_alt": "Preview",
  "os.admin.products.image_replace": "Replace",
  "os.admin.products.image_add": "Add a photo",
  "os.admin.products.image_hint": "Automatic square crop · JPG/PNG/WebP · 5 MB max",
  "os.admin.products.image_toast_format": "Unsupported format (JPG, PNG or WebP)",
  "os.admin.products.image_toast_too_large": "Image too large (5 MB max)",
  "os.admin.products.image_toast_added": "Photo added",
  "os.admin.products.image_toast_upload_error": "Upload failed",
  "os.admin.nav.group.pilotage": "Overview",
  "os.admin.nav.group.catalogue": "Catalog",
  "os.admin.nav.group.stock": "Stock",
  "os.admin.nav.group.cost": "Food cost",
  "os.admin.nav.group.loyalty": "Loyalty",
  "os.admin.nav.group.team": "Team",
  "os.admin.nav.group.settings": "Settings",
  "os.admin.nav.dashboard": "Dashboard",
  "os.admin.nav.orders": "Orders",
  "os.admin.nav.stats": "Statistics",
  "os.admin.nav.menu": "Menu & Recipes",
  "os.admin.nav.stock": "Stock",
  "os.admin.nav.ingredients": "Ingredients",
  "os.admin.nav.material_cost": "Food cost",
  "os.admin.nav.margins": "Margins",
  "os.admin.nav.inventory": "Material inventory",
  "os.admin.nav.rewards": "Rewards",
  "os.admin.nav.reviews": "Reviews",
  "os.admin.reviews.title": "Customer reviews",
  "os.admin.reviews.summary_average": "Average rating",
  "os.admin.reviews.summary_total": "Total reviews",
  "os.admin.reviews.summary_published": "Published",
  "os.admin.reviews.summary_hidden": "Hidden",
  "os.admin.reviews.distribution": "Rating distribution",
  "os.admin.reviews.list_label": "Reviews received",
  "os.admin.reviews.empty": "No reviews yet.",
  "os.admin.reviews.no_shop": "Select a store to view its reviews.",
  "os.admin.reviews.status_published": "Published",
  "os.admin.reviews.status_hidden": "Hidden",
  "os.admin.reviews.client_ref": "Customer",
  "os.admin.reviews.merchant_reply": "Merchant reply",
  "os.admin.reviews.reply": "Reply",
  "os.admin.reviews.edit_reply": "Edit reply",
  "os.admin.reviews.reply_title": "Reply to review",
  "os.admin.reviews.reply_placeholder": "Your reply (max 1000 characters)",
  "os.admin.reviews.reply_empty": "Reply cannot be empty.",
  "os.admin.reviews.send": "Send",
  "os.admin.reviews.hide": "Hide",
  "os.admin.reviews.show": "Show",
  "os.admin.reviews.toast_load_error": "Error loading reviews.",
  "os.admin.reviews.toast_reply_ok": "Reply saved.",
  "os.admin.reviews.toast_reply_error": "Error while sending the reply.",
  "os.admin.reviews.toast_toggle_ok": "Visibility updated.",
  "os.admin.reviews.toast_toggle_error": "Error updating visibility.",
  "os.admin.nav.team": "Team",
  "os.admin.nav.shop": "Store",
  "os.admin.nav.closures": "Z reports",
  "os.admin.nav.compliance": "Tax compliance",
  "os.admin.nav.audit": "Audit Log",
  "os.admin.common.no_shop_selected": "No store selected.",
  "os.admin.shop.create_title": "Create a store",
  "os.admin.shop.create_subtitle": "The currency is derived automatically from the country. You will be linked as the owner.",
  "os.admin.shop.field_name": "Store name",
  "os.admin.shop.field_address": "Address",
  "os.admin.shop.field_country": "Country",
  "os.admin.shop.field_timezone": "Time zone",
  "os.admin.shop.timezone_placeholder": "Select a time zone",
  "os.admin.shop.timezone_hint": "Establishment's local time (used for analytics)",
  "os.admin.shop.timezone_not_configured": "Time zone not configured",
  "os.admin.shop.timezone_suggestion": "Suggestion for this country:",
  "os.admin.shop.toast_timezone_invalid": "Invalid time zone",
  "os.admin.shop.placeholder_name": "E.g. SUPERKAWA Oran",
  "os.admin.shop.placeholder_address": "E.g. Seafront, Oran",
  "os.admin.shop.create_btn": "Create store",
  "os.admin.shop.edit_title": "Edit active store",
  "os.admin.shop.active_label": "Active store",
  "os.admin.shop.active_hint": "Visible and selectable in POS / OS",
  "os.admin.shop.save_changes_btn": "Save changes",
  "os.admin.shop.appearance_title": "My store's appearance",
  "os.admin.shop.appearance_subtitle": "Customize the storefront your customers see on SUPERKAWA.",
  "os.admin.shop.appearance_toast_format": "Unsupported format (JPG, PNG or WebP only)",
  "os.admin.shop.appearance_toast_too_large": "Image too large (5 MB maximum)",
  "os.admin.shop.appearance_toast_upload_error": "Error while uploading the image",
  "os.admin.shop.appearance_toast_update_error": "Error while saving changes",
  "os.admin.shop.appearance_toast_description_saved": "Description saved",
  "os.admin.shop.appearance_cover_label": "Cover photo",
  "os.admin.shop.appearance_cover_btn": "Edit cover photo",
  "os.admin.shop.appearance_cover_hint": "Preferably choose a horizontal photo of your establishment.",
  "os.admin.shop.appearance_logo_label": "Logo",
  "os.admin.shop.appearance_logo_add": "Add a logo",
  "os.admin.shop.appearance_logo_replace": "Change logo",
  "os.admin.shop.appearance_logo_hint": "The logo is optional. Without one, SUPERKAWA will display your store's initials.",
  "os.admin.shop.appearance_description_label": "Description",
  "os.admin.shop.appearance_description_hint": "Describe your concept, atmosphere, or specialty in a few words.",
  "os.admin.shop.appearance_description_save_btn": "Save description",
  "os.admin.shop.appearance_gallery_label": "Gallery",
  "os.admin.shop.appearance_gallery_add": "Add a photo",
  "os.admin.shop.appearance_gallery_replace": "Replace photo",
  "os.admin.shop.appearance_gallery_move_left": "Move left",
  "os.admin.shop.appearance_gallery_move_right": "Move right",
  "os.admin.shop.appearance_gallery_hint": "Add up to 5 photos of your establishment.",
  "os.admin.shop.appearance_gallery_subhint": "JPG, PNG or WebP · 5 MB maximum per photo. Photos are automatically optimized.",
  "os.admin.shop.seller_title": "Seller tax identity",
  "os.admin.shop.seller_subtitle": "Legal information of the establishment used for future B2B invoicing. All fields are optional.",
  "os.admin.shop.seller_legal_name": "Legal name",
  "os.admin.shop.seller_registration_number": "Registration number",
  "os.admin.shop.seller_tax_identifier": "Tax identifier",
  "os.admin.shop.seller_vat_identifier": "Intra-community VAT",
  "os.admin.shop.seller_address_section": "Billing address",
  "os.admin.shop.seller_street": "Street",
  "os.admin.shop.seller_postal_code": "Postal code",
  "os.admin.shop.seller_city": "City",
  "os.admin.shop.seller_country": "Country",
  "os.admin.shop.seller_contact_section": "Contact",
  "os.admin.shop.seller_contact_name": "Contact name",
  "os.admin.shop.seller_contact_email": "Email",
  "os.admin.shop.seller_contact_phone": "Phone",
  "os.admin.shop.seller_save_btn": "Save tax identity",
  "os.admin.shop.seller_saved": "Seller tax identity saved",
  "os.admin.shop.seller_save_error": "Error saving tax identity",
  "os.admin.shop.pause_title": "Service pause",
  "os.admin.shop.pause_subtitle": "Configure the message shown to customers when pause is activated from the POS.",
  "os.admin.shop.pause_state": "Current state:",
  "os.admin.shop.pause_state_paused": "Paused",
  "os.admin.shop.pause_state_active": "Service active",
  "os.admin.shop.pause_managed_pos": "Managed from the POS",
  "os.admin.shop.pause_type": "Pause type",
  "os.admin.shop.pause_simple": "Simple pause",
  "os.admin.shop.pause_salat": "Prayer pause",
  "os.admin.shop.pause_custom": "Custom message",
  "os.admin.shop.pause_custom_placeholder": "E.g. Inventory in progress, back at 2pm",
  "os.admin.operating.title": "Operating status",
  "os.admin.operating.subtitle": "Control your shop's availability. A pause or closure blocks new operations but does not affect orders already in progress.",
  "os.admin.operating.current": "Current state:",
  "os.admin.operating.reopen": "Reopen",
  "os.admin.operating.prayer_toggle": "Prayer pause",
  "os.admin.operating.prayer_hint": "Optional. Enables the \"Prayer\" reason for this shop only.",
  "os.admin.operating.status_label": "Status",
  "os.admin.operating.status_OPEN": "Open",
  "os.admin.operating.status_PAUSED": "Paused",
  "os.admin.operating.status_CLOSED": "Closed",
  "os.admin.operating.status_MAINTENANCE": "Maintenance",
  "os.admin.operating.status_SUSPENDED": "Suspended",
  "os.admin.operating.reason_label": "Reason",
  "os.admin.operating.reason_none": "No reason",
  "os.admin.operating.reason_BREAK": "Break",
  "os.admin.operating.reason_LUNCH": "Lunch",
  "os.admin.operating.reason_PRAYER": "Prayer",
  "os.admin.operating.reason_STAFF_SHORTAGE": "Staff shortage",
  "os.admin.operating.reason_TECHNICAL": "Technical issue",
  "os.admin.operating.reason_INVENTORY": "Inventory",
  "os.admin.operating.reason_OTHER": "Other",
  "os.admin.operating.message_label": "Public message (optional)",
  "os.admin.operating.message_placeholder": "E.g. Back at 2pm",
  "os.admin.operating.until_label": "Expected reopening (optional)",
  "os.admin.operating.saved": "Operating status updated",
  "os.admin.operating.reopened": "Shop reopened",
  "os.admin.operating.load_error": "Could not load operating status",
  "os.admin.operating.save_error": "Error updating status",
  "os.admin.shop.toast_name_address_required": "Name and address are required",
  "os.admin.shop.toast_country_not_supported": "This country is not enabled yet. Contact SUPERKAWA to enable it.",
  "os.admin.shop.toast_store_created": "Store \"{name}\" created in trial period.",
  "os.admin.shop.toast_store_create_error": "Error creating the store",
  "os.admin.shop.toast_store_updated": "Store updated",
  "os.admin.shop.toast_store_update_error": "Error during update",
  "os.admin.shop.toast_pause_load_error": "Could not load pause configuration",
  "os.admin.shop.toast_pause_saved": "Pause configuration saved",
  "os.admin.shop.toast_save_error": "Error during saving",
  "os.admin.shop.wl_title": "Wallet & Loyalty",
  "os.admin.shop.wl_subtitle_before": "Configure the wallet and loyalty for this store. The currency (",
  "os.admin.shop.wl_subtitle_after": ") is derived automatically from the country and cannot be changed.",
  "os.admin.shop.wl_wallet": "Wallet",
  "os.admin.shop.wl_wallet_enabled": "Wallet enabled",
  "os.admin.shop.wl_wallet_enabled_hint": "Customers can use a wallet in this store",
  "os.admin.shop.wl_recharge_enabled": "Top-up enabled",
  "os.admin.shop.wl_recharge_hint": "Allow wallet top-up",
  "os.admin.shop.wl_max_balance": "Maximum balance ({currency})",
  "os.admin.shop.wl_max_balance_placeholder": "Unlimited if empty",
  "os.admin.shop.wl_message": "Wallet message (optional)",
  "os.admin.shop.wl_message_placeholder": "E.g. Top up your wallet at the counter",
  "os.admin.shop.wl_loyalty": "Loyalty",
  "os.admin.shop.wl_loyalty_enabled": "Loyalty enabled",
  "os.admin.shop.wl_loyalty_hint": "Customers earn points in this store",
  "os.admin.shop.wl_ratio": "Points ratio ({currency} per 1 point)",
  "os.admin.shop.wl_ratio_placeholder_default": "Country default: {ratio}",
  "os.admin.shop.wl_ratio_placeholder": "Ratio",
  "os.admin.shop.wl_ratio_hint": "Leave empty to use the country default",
  "os.admin.shop.wl_ratio_hint_suffix": " ({ratio} {currency} / point)",
  "os.admin.shop.wl_points_name": "Points name (optional)",
  "os.admin.shop.wl_points_name_placeholder": "E.g. Kawas, Stars…",
  "os.admin.shop.wl_rewards_enabled": "Rewards enabled",
  "os.admin.shop.wl_rewards_hint": "Customers can redeem their points",
  "os.admin.shop.wl_save_btn": "Save Wallet & Loyalty",
  "os.admin.shop.wl_toast_load_error": "Could not load Wallet & Loyalty config",
  "os.admin.shop.wl_toast_saved": "Wallet & Loyalty configuration saved",
  "os.admin.shop.close_title": "Permanently close this store",
  "os.admin.shop.close_subtitle": "Irreversible action in this version: the store is archived and cannot be reopened from the app. Different from the daily pause/close above, which remains reversible.",
  "os.admin.shop.close_btn": "Permanently close this store",
  "os.admin.shop.close_preview_error": "Could not load closure information",
  "os.admin.shop.close_modal_title": "Permanently close {name}?",
  "os.admin.shop.close_scope_notice": "This action only affects {name}. The other stores in your business will remain active.",
  "os.admin.shop.close_wallet_label": "Client Wallet balance",
  "os.admin.shop.close_active_orders_label": "Active orders",
  "os.admin.shop.close_loyalty_label": "Loyalty points",
  "os.admin.shop.close_loyalty_hint": "Informational only — never blocks closure.",
  "os.admin.shop.close_affected_clients": "{count} client(s) affected",
  "os.admin.shop.close_blocked_intro": "Closure is blocked until the following points are resolved:",
  "os.admin.shop.close_confirm_btn": "Confirm closure",
  "os.admin.shop.close_success": "\"{name}\" has been permanently closed.",
  "os.admin.shop.close_already_archived": "This store is already closed.",
  "os.admin.shop.close_blocked_error": "Closure blocked: preconditions not met.",
  "os.admin.shop.close_forbidden_error": "You are not authorized to close this store.",
  "os.admin.shop.close_generic_error": "Error closing the store",
  "os.admin.shop.close_billing_warning_title": "Store closed — billing needs review",
  "os.admin.shop.close_billing_warning_body": "The store is closed, but the billing update could not be confirmed. The store will not be reopened. Billing synchronization will need to be retried.",
  "os.admin.shop.close_billing_warning_ack": "Got it",
  "os.admin.team.add_title": "Add a barista",
  "os.admin.team.add_subtitle_before": "Creates a barista account for ",
  "os.admin.team.add_subtitle_after": ". The barista only has access to this store's POS.",
  "os.admin.team.field_name": "Name",
  "os.admin.team.field_username": "Username",
  "os.admin.team.field_password": "Password",
  "os.admin.team.placeholder_name": "E.g. Sami Bensalem",
  "os.admin.team.placeholder_username": "E.g. Barista01",
  "os.admin.team.placeholder_password": "Barista password",
  "os.admin.team.show": "Show",
  "os.admin.team.hide": "Hide",
  "os.admin.team.create_btn": "Create barista",
  "os.admin.team.list_title": "Store baristas",
  "os.admin.team.list_empty": "No barista for this store.",
  "os.admin.team.badge_barista": "Barista",
  "os.admin.team.active": "Active",
  "os.admin.team.inactive": "Inactive",
  "os.admin.team.toast_load_error": "Could not load the team",
  "os.admin.team.toast_no_active_shop": "No active store selected",
  "os.admin.team.toast_required": "Name, username and password are required",
  "os.admin.team.toast_created": "Barista created",
  "os.admin.team.toast_create_error": "Error creating the barista",
  "os.admin.team.reset_password_btn": "Reset password",
  "os.admin.team.reset_password_title": "New password —",
  "os.admin.team.toast_reset_success": "Password reset",
  "os.admin.team.toast_reset_error": "Error resetting the password",
  "os.admin.account.password_title": "Account security",
  "os.admin.account.password_subtitle": "Change the password for your owner/staff account.",
  "os.admin.account.toast_password_updated": "Password updated",
  "os.admin.account.toast_password_error": "Error updating the password",
  "os.admin.rewards.no_shop": "Select a store to manage its rewards.",
  "os.admin.rewards.title": "Loyalty rewards",
  "os.admin.rewards.subtitle_before": "Rewards specific to ",
  "os.admin.rewards.add_btn": "New reward",
  "os.admin.rewards.empty_title": "No reward has been created yet.",
  "os.admin.rewards.empty_desc": "Start by creating your first loyalty reward. You can edit it at any time.",
  "os.admin.rewards.empty_cta": "Create a reward",
  "os.admin.rewards.inactive_badge": "Inactive",
  "os.admin.rewards.pts": "pts",
  "os.admin.rewards.order_label": "order {order}",
  "os.admin.rewards.deactivate_title": "Deactivate",
  "os.admin.rewards.reactivate_title": "Reactivate",
  "os.admin.rewards.dialog_edit_title": "Edit reward",
  "os.admin.rewards.dialog_new_title": "New reward",
  "os.admin.rewards.field_name": "Name",
  "os.admin.rewards.field_name_placeholder": "E.g. Free espresso",
  "os.admin.rewards.field_description": "Description",
  "os.admin.rewards.field_description_placeholder": "Optional description",
  "os.admin.rewards.field_points": "Points required",
  "os.admin.rewards.field_type": "Type",
  "os.admin.rewards.field_sort": "Display order",
  "os.admin.rewards.active_label": "Active",
  "os.admin.rewards.inactive_label": "Inactive",
  "os.admin.rewards.type_boisson": "Drink",
  "os.admin.rewards.type_snack": "Snack",
  "os.admin.rewards.type_topping": "Topping",
  "os.admin.rewards.type_upgrade": "Upgrade",
  "os.admin.rewards.type_autre": "Other",
  "os.admin.rewards.toast_load_error": "Could not load rewards",
  "os.admin.rewards.toast_name_required": "Name is required",
  "os.admin.rewards.toast_points_invalid": "Points required: positive integer",
  "os.admin.rewards.toast_updated": "Reward updated",
  "os.admin.rewards.toast_created": "Reward created",
  "os.admin.rewards.toast_save_error": "Save failed",
  "os.admin.rewards.toast_deactivated": "Reward deactivated",
  "os.admin.rewards.toast_deactivate_error": "Deactivation failed",
  "os.admin.rewards.toast_reactivated": "Reward reactivated",
  "os.admin.rewards.toast_reactivate_error": "Reactivation failed",
  "os.admin.stats.orders_by_status": "Orders by status",
  "os.admin.stats.orders_empty_title": "No orders to display",
  "os.admin.stats.orders_empty_desc": "Order statuses will appear here after the first sale.",
  "os.admin.stats.revenue_by_payment": "Revenue by payment method",
  "os.admin.stats.revenue_empty_title": "No revenue recorded",
  "os.admin.stats.revenue_empty_desc": "The breakdown by payment method will show after your first sales.",
  "os.admin.stats.pay_wallet": "Wallet",
  "os.admin.stats.pay_cash": "Cash",
  "os.admin.stats.orders_count": "{count} order(s)",
  "os.admin.stats.top_products": "Top 10 products",
  "os.admin.stats.top_empty_title": "No product sold",
  "os.admin.stats.top_empty_desc": "Your best sellers ranking will appear here.",
  "os.admin.stats.sold": "{count} sold",
  "os.admin.closures.toast_load_error": "Could not load Z reports",
  "os.admin.closures.toast_select_shop": "Select a store before closing.",
  "os.admin.closures.toast_period_required": "Enter a period (start and end).",
  "os.admin.closures.toast_period_order": "The start date must be strictly before the end date.",
  "os.admin.closures.toast_idempotent": "This period is already closed (Z #{number}).",
  "os.admin.closures.toast_sealed": "Z report #{number} sealed ({count} ticket(s)).",
  "os.admin.closures.err_forbidden": "Access denied to this store.",
  "os.admin.closures.err_invalid_period": "Invalid period.",
  "os.admin.closures.err_failed": "Closure failed.",
  "os.admin.closures.no_shop_title": "Select a store",
  "os.admin.closures.no_shop_desc": "Choose a store to manage its Z reports.",
  "os.admin.closures.title": "Z reports (NF525)",
  "os.admin.closures.subtitle_before": "Sealed and chained closures of ",
  "os.admin.closures.create_btn": "Close (Z)",
  "os.admin.closures.empty_title": "No Z report for this store.",
  "os.admin.closures.empty_desc": "Create a Z report to seal the revenue of a period.",
  "os.admin.closures.integrity_ok": "Intact",
  "os.admin.closures.integrity_altered": "Altered",
  "os.admin.closures.row_meta": "{count} ticket(s) · sealed on {date}",
  "os.admin.closures.ttc": "incl. VAT",
  "os.admin.closures.dialog_title": "New Z report",
  "os.admin.closures.dialog_desc_before": "The closure seals the revenue of ",
  "os.admin.closures.dialog_desc_after": " over the chosen period. An already closed period is never recreated.",
  "os.admin.closures.field_start": "Period start",
  "os.admin.closures.field_end": "Period end",
  "os.admin.closures.field_hint": "The end is exclusive: to close one day, choose that day as start and the next day as end.",
  "os.admin.closures.archive_title": "Fiscal archives (NF525)",
  "os.admin.closures.dl_json": "Download JSON",
  "os.admin.closures.dl_csv": "Download CSV",
  "os.admin.closures.dl_pdf": "Download PDF",
  "os.admin.closures.verify_btn": "Verify archive",
  "os.admin.closures.archive_version": "Archive version",
  "os.admin.closures.generated_at": "Generated on",
  "os.admin.closures.archive_hash": "Archive hash (SHA-256)",
  "os.admin.closures.archive_valid": "Valid archive",
  "os.admin.closures.archive_invalid": "Invalid archive",
  "os.admin.closures.v_hash": "Hash:",
  "os.admin.closures.v_signature": "Signature:",
  "os.admin.closures.v_closure": "Closure:",
  "os.admin.closures.v_receipts": "Receipts:",
  "os.admin.closures.anomalies": "Anomalies detected:",
  "os.admin.closures.toast_json_ok": "JSON archive downloaded.",
  "os.admin.closures.toast_json_error": "Failed to download the JSON archive.",
  "os.admin.closures.toast_csv_ok": "CSV export downloaded.",
  "os.admin.closures.toast_csv_error": "Failed to download the CSV.",
  "os.admin.closures.toast_pdf_ok": "PDF archive downloaded.",
  "os.admin.closures.toast_pdf_error": "Failed to download the PDF.",
  "os.admin.closures.toast_verify_ok": "Archive verified: intact and authentic.",
  "os.admin.closures.toast_verify_invalid": "Invalid archive: anomalies detected.",
  "os.admin.closures.toast_verify_error": "Failed to verify the archive.",
  "os.admin.closures.detail_title": "Z report #{number}",
  "os.admin.closures.d_number": "Z number",
  "os.admin.closures.d_period_start": "Period (start)",
  "os.admin.closures.d_period_end": "Period (end, exclusive)",
  "os.admin.closures.d_tickets": "Tickets",
  "os.admin.closures.d_sealed": "Sealed on",
  "os.admin.closures.d_ttc": "Total (incl. VAT)",
  "os.admin.closures.d_ht": "Total (excl. VAT)",
  "os.admin.closures.d_tva": "Total VAT",
  "os.admin.closures.d_refunds": "Refunds",
  "os.admin.closures.d_net": "Informational net",
  "os.admin.closures.pay_breakdown": "Breakdown by payment method",
  "os.admin.closures.no_data": "No data.",
  "os.admin.closures.vat_breakdown": "VAT breakdown",
  "os.admin.closures.vat_tickets": "{count} ticket(s)",
  "os.admin.closures.label_ht": "excl. VAT:",
  "os.admin.closures.label_tva": "VAT:",
  "os.admin.closures.crypto_seal": "Cryptographic seal",
  "os.admin.closures.prev_z_hash": "Previous Z hash",
  "os.admin.closures.integrity_anomalies": "Integrity anomalies detected",
  "os.admin.closures.pay_card": "Card",
  "os.admin.closures.pay_cash": "Cash",
  "os.admin.closures.pay_wallet": "Wallet",
  "os.admin.recipes.title": "SUPERKAWA Recipes",
  "os.admin.recipes.subtitle": "Standardized central catalog. Select your store recipes.",
  "os.admin.recipes.refresh": "Refresh",
  "os.admin.recipes.selected_count_one": "{count} recipe selected",
  "os.admin.recipes.selected_count_many": "{count} recipes selected",
  "os.admin.recipes.hint_select_shop": "— select a store to manage the selection",
  "os.admin.recipes.hint_readonly": "— read-only (owner only)",
  "os.admin.recipes.sync_btn": "Sync selected recipes",
  "os.admin.recipes.sync_title_dirty": "Save your selection first",
  "os.admin.recipes.sync_title_default": "Creates the missing draft products",
  "os.admin.recipes.search_placeholder": "Search a recipe...",
  "os.admin.recipes.category_placeholder": "Category",
  "os.admin.recipes.all_categories": "All categories",
  "os.admin.recipes.error": "Could not load recipes.",
  "os.admin.recipes.empty": "No recipe available yet.",
  "os.admin.recipes.no_result": "No recipe matches your search.",
  "os.admin.recipes.section_drinks": "Drinks",
  "os.admin.recipes.section_food": "Cookies / Food",
  "os.admin.recipes.empty_drinks": "No drink in this selection.",
  "os.admin.recipes.empty_food": "No Cookies / Food recipe yet.",
  "os.admin.recipes.ingredients": "Ingredients",
  "os.admin.recipes.steps": "Steps",
  "os.admin.recipes.tip": "Tip",
  "os.admin.recipes.card_selected": "Selected",
  "os.admin.recipes.card_select": "Select",
  "os.admin.recipes.card_legacy": "Legacy — not selectable",
  "os.admin.recipes.toast_sel_load_error": "Could not load the store selection",
  "os.admin.recipes.toast_sel_saved": "Selection saved",
  "os.admin.recipes.toast_sync_dirty": "Save your selection before syncing",
  "os.admin.recipes.toast_sync_empty": "No recipe selected to sync",
  "os.admin.recipes.sync_added": "{count} added to the menu",
  "os.admin.recipes.sync_updated": "{count} updated",
  "os.admin.recipes.sync_hidden": "{count} hidden",
  "os.admin.recipes.sync_nochange": "No change",
  "os.admin.recipes.toast_sync_summary": "{summary}. Products visible in App + POS — set the price in Products.",
  "os.admin.recipes.toast_sync_error": "Sync failed",
  "os.admin.recipes.cat_cafe": "Coffee",
  "os.admin.recipes.cat_froid": "Cold",
  "os.admin.recipes.cat_cookies": "Cookies",
  "os.admin.recipes.cat_food": "Food",
  "os.admin.recipes.cat_patisserie": "Pastry",
  "os.admin.recipes.cat_dessert": "Dessert",
  "os.admin.recipes.cat_snack": "Snack",
  "os.admin.recipes.cat_espresso_classiques": "Espresso & Classics",
  "os.admin.recipes.cat_signatures": "Signatures",
  "os.admin.recipes.cat_africaines": "African",
  "os.admin.recipes.cat_asiatiques": "Asian",
  "os.admin.recipes.cat_iced_cold": "Iced & Cold",
  "os.admin.recipes.cat_saisonnieres": "Seasonal",
  "os.admin.recipes.cat_sans_cafe": "Caffeine-free & Mocktails",
  // MB-I18N-4 — Finished product stock
  "os.admin.stock.status_ok": "OK",
  "os.admin.stock.status_low": "Low stock",
  "os.admin.stock.status_out": "Out of stock",
  "os.admin.stock.status_unknown": "Not initialised",
  "os.admin.stock.title": "Stock",
  "os.admin.stock.tracked_count": "{count} tracked product(s)",
  "os.admin.stock.refresh": "Refresh",
  "os.admin.stock.error_load": "Unable to load this shop's stock.",
  "os.admin.stock.retry": "Retry",
  "os.admin.stock.alert_banner": "{count} product(s) to restock",
  "os.admin.stock.alert_rupture": "out of stock",
  "os.admin.stock.enable_title": "Enable tracking for a product",
  "os.admin.stock.select_placeholder": "Choose a product…",
  "os.admin.stock.select_all_tracked": "All products are already tracked",
  "os.admin.stock.track_btn": "Track",
  "os.admin.stock.empty": "No tracked product yet.",
  "os.admin.stock.qty_placeholder": "Qty",
  "os.admin.stock.add": "Add",
  "os.admin.stock.remove": "Remove",
  "os.admin.stock.set": "Set",
  "os.admin.stock.threshold": "Threshold",
  "os.admin.stock.history": "History",
  "os.admin.stock.untrack": "Stop tracking",
  "os.admin.stock.history_title": "History — {name}",
  "os.admin.stock.no_movement": "No movement.",
  "os.admin.stock.toast_track_on": "Stock tracking enabled",
  "os.admin.stock.toast_track_off": "Stock tracking disabled",
  "os.admin.stock.toast_track_on_error": "Failed to enable tracking",
  "os.admin.stock.toast_track_off_error": "Failed to disable",
  "os.admin.stock.toast_qty_invalid": "Invalid quantity",
  "os.admin.stock.toast_updated": "Stock updated",
  "os.admin.stock.toast_adjust_error": "Failed to adjust",
  "os.admin.stock.toast_threshold_invalid": "Invalid threshold",
  "os.admin.stock.toast_threshold_saved": "Threshold saved",
  "os.admin.stock.toast_threshold_error": "Failed to save threshold",
  "os.admin.stock.toast_history_error": "Failed to load history",
  // MB-I18N-4 — Material cost onboarding
  "os.admin.cost_onboarding.step_done": "Done",
  "os.admin.cost_onboarding.step_todo": "To do",
  "os.admin.cost_onboarding.title": "Material cost setup",
  "os.admin.cost_onboarding.subtitle": "Follow these 3 steps to get your first computable margin.",
  "os.admin.cost_onboarding.step1_title": "Generate ingredients",
  "os.admin.cost_onboarding.step1_desc": "Create your catalog from the standards.",
  "os.admin.cost_onboarding.step2_title": "Complete purchase prices",
  "os.admin.cost_onboarding.step2_progress": "{priced} ingredient(s) completed / {total} total ingredient(s)",
  "os.admin.cost_onboarding.step3_title": "Review margins",
  "os.admin.cost_onboarding.step3_desc": "At least one computable recipe is enough to validate.",
  "os.admin.cost_onboarding.cta_ingredients": "Go to Ingredients",
  "os.admin.cost_onboarding.cta_material_cost": "View Material cost",
  "os.admin.cost_onboarding.cta_margins": "View Margins",
  // MB-I18N-4 — Units
  "os.admin.units.piece": "piece",
  "os.admin.units.portion": "portion",
  "os.admin.units.shot": "shot",
  "os.admin.units.spoon": "spoon",
  // MB-I18N-4 — Ingredients
  "os.admin.ingredients.std_linked": "Linked",
  "os.admin.ingredients.std_suggestion": "Suggestion available",
  "os.admin.ingredients.std_unknown": "Not recognised",
  "os.admin.ingredients.error_load": "Unable to load this shop's ingredients.",
  "os.admin.ingredients.retry": "Retry",
  "os.admin.ingredients.title": "Ingredients",
  "os.admin.ingredients.count": "{count} ingredient(s) · per-shop catalog",
  "os.admin.ingredients.generate_btn": "Generate ingredients from standards",
  "os.admin.ingredients.autodetect_btn": "Auto-detect standards",
  "os.admin.ingredients.add_btn": "Add an ingredient",
  "os.admin.ingredients.coverage_standards": "Standards covered",
  "os.admin.ingredients.coverage_ingredients": "Linked ingredients",
  "os.admin.ingredients.coverage_reliability": "Material cost reliability",
  "os.admin.ingredients.coverage_reliability_hint": "overall recipe coverage",
  "os.admin.ingredients.missing_standards": "Unlinked standards ({count})",
  "os.admin.ingredients.copy_missing": "Copy missing standards",
  "os.admin.ingredients.search_placeholder": "Search an ingredient…",
  "os.admin.ingredients.show_inactive": "Show inactive",
  "os.admin.ingredients.empty": "No ingredient yet. Add your first ingredient.",
  "os.admin.ingredients.inactive": "Inactive",
  "os.admin.ingredients.supplier_label": "Supplier: {name}",
  "os.admin.ingredients.link_apply": "Apply",
  "os.admin.ingredients.link_manual": "Link manually",
  "os.admin.ingredients.price_pending": "Price to complete",
  "os.admin.ingredients.per_unit": "per {unit}",
  "os.admin.ingredients.edit": "Edit",
  "os.admin.ingredients.deactivate": "Deactivate",
  "os.admin.ingredients.reactivate": "Reactivate",
  "os.admin.ingredients.dialog_edit_title": "Edit ingredient",
  "os.admin.ingredients.dialog_new_title": "New ingredient",
  "os.admin.ingredients.field_name": "Name",
  "os.admin.ingredients.field_name_placeholder": "e.g. Whole milk",
  "os.admin.ingredients.field_base_unit": "Reference unit",
  "os.admin.ingredients.field_unit_cost": "Unit cost ({currency}/{unit})",
  "os.admin.ingredients.field_unit_cost_placeholder": "e.g. 0.0018",
  "os.admin.ingredients.field_standard": "Standard (material cost)",
  "os.admin.ingredients.standard_none_placeholder": "None",
  "os.admin.ingredients.standard_none": "None (unlinked)",
  "os.admin.ingredients.standard_hint": "Link this ingredient to a Coffee-Only standard for the material cost calculation.",
  "os.admin.ingredients.field_supplier": "Supplier (optional)",
  "os.admin.ingredients.field_supplier_placeholder": "e.g. Local dairy",
  "os.admin.ingredients.cancel": "Cancel",
  "os.admin.ingredients.save": "Save",
  "os.admin.ingredients.autodetect_title": "Standards auto-detection",
  "os.admin.ingredients.autodetect_desc": "Suggestions based on Coffee-Only standard aliases. Uncheck any you don't want to apply. Nothing is applied without your confirmation.",
  "os.admin.ingredients.match_exact": "exact",
  "os.admin.ingredients.match_alias": "alias",
  "os.admin.ingredients.autodetect_empty": "No suggestion available.",
  "os.admin.ingredients.autodetect_apply": "Apply selection ({count})",
  "os.admin.ingredients.generate_title": "Generate ingredients from standards",
  "os.admin.ingredients.generate_report_a": "ingredient(s) generated with a cost of 0 (",
  "os.admin.ingredients.generate_report_b": "). No price was made up: enter your real purchase costs for each ingredient.",
  "os.admin.ingredients.generate_price_pending": "price to complete",
  "os.admin.ingredients.generate_preview_a": "ingredient(s) will be created with",
  "os.admin.ingredients.generate_preview_b": "and a",
  "os.admin.ingredients.generate_preview_status": "\"Price to complete\"",
  "os.admin.ingredients.generate_preview_c": " status. Sub-recipes are excluded.",
  "os.admin.ingredients.generate_preview_d": "No price is made up: you will need to enter your real purchase costs after generation.",
  "os.admin.ingredients.generate_nothing": "All required standards are already linked. Nothing to generate.",
  "os.admin.ingredients.generate_already_linked": "Already linked: {count}",
  "os.admin.ingredients.generate_sub_recipes": "Excluded sub-recipes: {list}",
  "os.admin.ingredients.generate_name_clash": "Ignored name conflicts: {count}",
  "os.admin.ingredients.generate_confirm_label": "To confirm, type exactly:",
  "os.admin.ingredients.generate_close": "Close",
  "os.admin.ingredients.generate_apply": "Generate {count} ingredient(s)",
  "os.admin.ingredients.generate_0_todo": "0 to complete",
  "os.admin.ingredients.toast_name_required": "Name is required",
  "os.admin.ingredients.toast_cost_invalid": "Invalid unit cost (≥ 0)",
  "os.admin.ingredients.toast_updated": "Ingredient updated",
  "os.admin.ingredients.toast_added": "Ingredient added",
  "os.admin.ingredients.toast_save_error": "Failed to save",
  "os.admin.ingredients.toast_deactivated": "Ingredient deactivated",
  "os.admin.ingredients.toast_reactivated": "Ingredient reactivated",
  "os.admin.ingredients.toast_toggle_error": "Failed",
  "os.admin.ingredients.toast_linked": "\"{name}\" linked to {standard}",
  "os.admin.ingredients.toast_link_error": "Failed to link",
  "os.admin.ingredients.toast_none_selected": "No suggestion selected",
  "os.admin.ingredients.toast_linked_multi": "{ok} ingredient(s) linked",
  "os.admin.ingredients.toast_linked_multi_fail": "{ok} ingredient(s) linked, {fail} failure(s)",
  "os.admin.ingredients.toast_none_applied": "No link applied",
  "os.admin.ingredients.toast_preview_error": "Failed to load preview",
  "os.admin.ingredients.toast_confirm_exact": "Type exactly \"GEN-INGREDIENTS\" to confirm.",
  "os.admin.ingredients.toast_generated": "{count} ingredient(s) generated · price to complete",
  "os.admin.ingredients.toast_generate_error": "Generation failed",
  "os.admin.ingredients.toast_copy_ok": "List copied",
  "os.admin.ingredients.toast_copy_error": "Unable to copy the list",
  // MB-I18N-4 — Material cost
  "os.admin.material_cost.status_ok": "OK",
  "os.admin.material_cost.status_missing": "To price",
  "os.admin.material_cost.status_unit_mismatch": "Unit mismatch",
  "os.admin.material_cost.status_price_pending": "Price to complete",
  "os.admin.material_cost.loading": "Loading material cost…",
  "os.admin.material_cost.error": "Error loading material cost.",
  "os.admin.material_cost.title": "Material cost",
  "os.admin.material_cost.subtitle": "Material cost computed from the establishment's recipes and the shop's ingredient costs.",
  "os.admin.material_cost.summary_recipes": "Recipes analysed",
  "os.admin.material_cost.summary_computable": "Fully priced",
  "os.admin.material_cost.summary_coverage": "Overall coverage",
  "os.admin.material_cost.empty": "No recipe to display. Enter costs in the Ingredients tab.",
  "os.admin.material_cost.partial": "partial",
  "os.admin.material_cost.col_ingredient": "Ingredient",
  "os.admin.material_cost.col_qty": "Quantity",
  "os.admin.material_cost.col_cost": "Cost",
  "os.admin.material_cost.col_status": "Status",
  "os.admin.material_cost.missing_count": "{count} ingredient(s) to price",
  "os.admin.material_cost.cta_ingredients": "Enter in Ingredients",
  "os.admin.material_cost.optional_excluded": "Optional (excluded from cost):",
  "os.admin.material_cost.zero_cost": "Included at no cost:",
  "os.admin.material_cost.currency_warning": "Multiple currencies detected: {list}",
  // MB-I18N-4 — Margins
  "os.admin.margins.error_load": "Unable to load this shop's margins.",
  "os.admin.margins.retry": "Retry",
  "os.admin.margins.title": "Margins",
  "os.admin.margins.subtitle": "Gross material margin = sale price − material cost (excl. labour, overheads, VAT).",
  "os.admin.margins.summary_calculable": "Computable products",
  "os.admin.margins.summary_margin": "Average margin rate",
  "os.admin.margins.summary_foodcost": "Average food cost",
  "os.admin.margins.empty": "No product linked to a recipe for this shop.",
  "os.admin.margins.empty_cta": "Go to Products",
  "os.admin.margins.top": "Top margins",
  "os.admin.margins.low": "Low margins",
  "os.admin.margins.noncalc": "Non-computable products ({count})",
  "os.admin.margins.metric_sale_price": "Sale price",
  "os.admin.margins.metric_material_cost": "Material cost",
  "os.admin.margins.metric_gross_margin": "Gross material margin",
  "os.admin.margins.metric_margin_rate": "Margin rate",
  "os.admin.margins.metric_food_cost": "Food cost",
  "os.admin.margins.metric_multiplier": "Multiplier",
  "os.admin.margins.cta_set_price": "Set a price",
  "os.admin.margins.cta_ingredients": "Enter ingredients",
  "os.admin.margins.cta_material_cost": "View material cost",
  "os.admin.margins.cta_check_ingredients": "Check ingredients",
  "os.admin.margins.reasons.no_price": "Missing sale price",
  "os.admin.margins.reasons.cost_incomplete": "Incomplete material cost",
  "os.admin.margins.reasons.no_recipe_cost": "Recipe cannot be priced",
  "os.admin.margins.reasons.currency_mismatch": "Mixed ingredient currencies",
  "os.admin.margins.reasons.unknown": "Not computable",
  // MB-I18N-4 — Material inventory
  "os.admin.inventory.status_ok": "OK",
  "os.admin.inventory.status_low": "Low",
  "os.admin.inventory.status_out": "Out of stock",
  "os.admin.inventory.status_unknown": "Not initialised",
  "os.admin.inventory.status_non_suivi": "Not tracked",
  "os.admin.inventory.mv_sale": "Sale",
  "os.admin.inventory.mv_restock": "Restock",
  "os.admin.inventory.mv_loss": "Loss/Breakage",
  "os.admin.inventory.mv_adjust": "Adjustment",
  "os.admin.inventory.mv_inventory": "Stocktake",
  "os.admin.inventory.error_load": "Unable to load this shop's material inventory.",
  "os.admin.inventory.retry": "Retry",
  "os.admin.inventory.header_title": "Material inventory",
  "os.admin.inventory.header_subtitle": "Ingredient (raw material) stock tracking. Stock is decremented automatically when orders are completed.",
  "os.admin.inventory.empty": "No ingredient in this shop. Add your ingredients to track material stock.",
  "os.admin.inventory.empty_cta": "Manage ingredients",
  "os.admin.inventory.kpi_tracked": "Tracked ingredients",
  "os.admin.inventory.kpi_low": "Low alerts",
  "os.admin.inventory.kpi_out": "Out of stock",
  "os.admin.inventory.kpi_mv7": "Movements 7d",
  "os.admin.inventory.none_tracked": "No ingredient tracked yet. Enable tracking on an ingredient below to start.",
  "os.admin.inventory.alerts_title": "To restock ({count})",
  "os.admin.inventory.col_ingredient": "Ingredient",
  "os.admin.inventory.col_standard": "Standard",
  "os.admin.inventory.col_stock": "Stock",
  "os.admin.inventory.col_unit": "Unit",
  "os.admin.inventory.col_threshold": "Threshold",
  "os.admin.inventory.col_status": "Status",
  "os.admin.inventory.col_actions": "Actions",
  "os.admin.inventory.restock": "Restock",
  "os.admin.inventory.loss": "Loss",
  "os.admin.inventory.inventory": "Stocktake",
  "os.admin.inventory.track_activate": "Enable tracking",
  "os.admin.inventory.dialog_restock": "Supplier delivery",
  "os.admin.inventory.dialog_loss": "Loss / breakage",
  "os.admin.inventory.dialog_inventory": "Physical stocktake",
  "os.admin.inventory.field_physical_stock": "Observed physical stock ({unit})",
  "os.admin.inventory.field_qty": "Quantity ({unit})",
  "os.admin.inventory.placeholder_inventory": "e.g. 4500",
  "os.admin.inventory.placeholder_qty": "e.g. 1000",
  "os.admin.inventory.current_stock": "Current stock: {qty} {unit}",
  "os.admin.inventory.reason": "Reason",
  "os.admin.inventory.reason_optional": "(optional)",
  "os.admin.inventory.placeholder_reason_loss": "e.g. breakage, expiry",
  "os.admin.inventory.placeholder_reason_inventory": "e.g. monthly stocktake",
  "os.admin.inventory.placeholder_reason_restock": "e.g. supplier delivery",
  "os.admin.inventory.cancel": "Cancel",
  "os.admin.inventory.validate": "Confirm",
  "os.admin.inventory.track_dialog_title": "Stock tracking — {name}",
  "os.admin.inventory.field_initial_stock": "Initial stock ({unit})",
  "os.admin.inventory.field_threshold": "Alert threshold ({unit})",
  "os.admin.inventory.placeholder_initial": "e.g. 5000",
  "os.admin.inventory.placeholder_threshold": "e.g. 1000",
  "os.admin.inventory.untrack": "Stop tracking",
  "os.admin.inventory.save": "Save",
  "os.admin.inventory.toast_qty_invalid": "Invalid quantity",
  "os.admin.inventory.toast_reason_required": "Reason required",
  "os.admin.inventory.toast_updated": "Stock updated",
  "os.admin.inventory.toast_update_error": "Update failed",
  "os.admin.inventory.toast_track_on": "Tracking enabled",
  "os.admin.inventory.toast_track_off": "Tracking disabled",
  "os.admin.inventory.history_title": "History — {name}",
  "os.admin.inventory.history_empty": "No movement recorded.",
  "os.admin.inventory.hist_col_date": "Date",
  "os.admin.inventory.hist_col_type": "Type",
  "os.admin.inventory.hist_col_qty": "Quantity",
  "os.admin.inventory.hist_col_stock_after": "Stock after",
  "os.admin.inventory.hist_col_reason": "Reason",
};
